import React from "react";
import { useTranslation } from "react-i18next";
import { Brands, Footer, Header, LinkListItem } from "@fce-bees/fce-common-components";
import { useLocation, useNavigate } from "react-router-dom";
import { useCase } from "src/context/case-context";

interface LayoutProps {
  readonly children: React.ReactNode;
}

const AUTH_PATHS = new Set(["/"]);

export function Layout({ children }: LayoutProps) {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const { caseReference, clearCustomerData } = useCase();

  const isAuthPage = AUTH_PATHS.has(pathname);

  const year = new Date().getFullYear().toString();
  const copyrightText = t("footerCopyright", { year });

  const footerItems = t("footerList", {
    returnObjects: true,
  }) as Array<{ url: string; linkText: string }>;

  const translatedFooterItems: LinkListItem[] = footerItems.map((item) => ({
    ...item,
    openNewTab: true,
  }));

  const handleSignOut = () => {
    clearCustomerData();

    navigate("/", {
      replace: true,
    });
  };

  return (
    <div className="flex flex-col min-h-screen">
      {!isAuthPage && (
        <Header
          brand={Brands.FordCredit}
          authentication={true}
          logoutText={t("header.signOut")}
          onLogout={handleSignOut}
          manageCredentialButtonText={`Case reference ${caseReference}`}
          className="shadow-[0_3px_12px_#f5f5f5] border-b-[#f0f0f0] border-b border-solid"
        />
      )}

      <main
        className={`flex flex-col flex-grow items-center justify-center bg-white w-full text-left ${
          isAuthPage ? "" : "pt-16"
        }`}
      >
        {children}
      </main>

      <Footer brand={Brands.Consumer} footerCopyright={copyrightText} footerItems={translatedFooterItems} />
    </div>
  );
}
